import React from "react";
import moment from "moment";
import { Translation, t } from "../../../core/translate";
import { Stopwatch, Warning } from "@vitalsource/vstui-icons";
import { RedStopwatch } from "./red-stopwatch";

const formatTermsMessage = (termsDuration, termsAbsDate) => {
  let label = "";
  if (termsDuration) {
    if (termsDuration < 24) {
      label = (
        <Translation id="library.loan-duration-hours" hours={termsDuration} />
      );
    } else {
      label = (
        <Translation
          id="library.loan-duration-days"
          days={parseInt(termsDuration / 24)}
        />
      );
    }
  }
  if (termsAbsDate) {
    label = <Translation id="library.loan-end-date" date={termsAbsDate} />;
  }
  if (label !== "") {
    return {
      Icon: Stopwatch,
      label: label
    };
  }
  return {};
};
const formatExpirationMessage = expirationTimestamp => {
  let message = {};
  if (expirationTimestamp) {
    const duration = moment.duration(
      new Date(expirationTimestamp) - new Date(),
      "milliseconds"
    );
    const days = parseInt(duration.asDays());
    if (days === 0) {
      message = {
        Icon: RedStopwatch,
        label: <Translation id="library.loan-expires-less-day" />
      };
    } else {
      message = {
        Icon: Stopwatch,
        label: <Translation id="library.loan-expiry-days" days={days} />
      };
    }
  }
  return message;
};
export const getDurationMessage = (
  isCreditAsset,
  termsDuration,
  termsAbsDate,
  expirationTimestamp,
  active,
  distributable
) => {
  if (isCreditAsset) {
    if (expirationTimestamp && active) {
      return formatExpirationMessage(expirationTimestamp);
    }
    return distributable ? formatTermsMessage(termsDuration, termsAbsDate) : {};
  }
  return {};
};

export const getAvailabilityMessage = (
  hasAvailableCopies,
  hasAvailableUserCreditsForAsset,
  active,
  distributable
) => {
  if (!active) {
    let label = "";
    if (!distributable) {
      label = t("library.book.unavailable");
    } else if (!hasAvailableCopies) {
      label = t("library.all-copies-in-use");
    } else if (!hasAvailableUserCreditsForAsset && hasAvailableCopies) {
      label = t("library.borrow-limit-reached");
    }
    if (label !== "") {
      return {
        icon: <Warning />,
        label: label
      };
    }
  }
  return {};
};
